import React from "react";
import { Icon, type IconProps } from "@chakra-ui/react";

export function HeroImage({
  sourceImage,
  destinationImage,
  ...props
}: { sourceImage: string; destinationImage: string } & IconProps) {
  return (
    <Icon fill="none" viewBox="0 0 544 254" width="544px" height="254px" {...props}>
      <g filter="url(#a)">
        <rect width="50" height="50" x="84" y="204" fill="#fff" rx="5" transform="rotate(-180 84 204)" />
        <rect
          width="48.5"
          height="48.5"
          x="83.25"
          y="203.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="4.25"
          transform="rotate(-180 83.25 203.25)"
        />
      </g>
      <g filter="url(#b)">
        <rect width="50" height="50" x="510" y="96" fill="#fff" rx="5" transform="rotate(-180 510 96)" />
        <rect
          width="48.5"
          height="48.5"
          x="509.25"
          y="95.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="4.25"
          transform="rotate(-180 509.25 95.25)"
        />
      </g>
      <g filter="url(#c)">
        <rect width="30" height="30" x="36" y="107" fill="#fff" rx="4" transform="rotate(-180 36 107)" />
        <rect
          width="28.5"
          height="28.5"
          x="35.25"
          y="106.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="3.25"
          transform="rotate(-180 35.25 106.25)"
        />
      </g>
      <g filter="url(#d)">
        <rect width="30" height="30" x="538" y="176" fill="#fff" rx="4" transform="rotate(-180 538 176)" />
        <rect
          width="28.5"
          height="28.5"
          x="537.25"
          y="175.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="3.25"
          transform="rotate(-180 537.25 175.25)"
        />
      </g>
      <g filter="url(#e)">
        <rect width="20" height="20" x="65" y="49" fill="#fff" rx="3" transform="rotate(-180 65 49)" />
        <rect
          width="18.5"
          height="18.5"
          x="64.25"
          y="48.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="2.25"
          transform="rotate(-180 64.25 48.25)"
        />
      </g>
      <g filter="url(#f)">
        <rect width="15" height="15" x="132" y="19" fill="#fff" rx="2" transform="rotate(-180 132 19)" />
        <rect
          width="13.5"
          height="13.5"
          x="131.25"
          y="18.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="1.25"
          transform="rotate(-180 131.25 18.25)"
        />
      </g>
      <g filter="url(#g)">
        <rect width="15" height="15" x="426" y="250" fill="#fff" rx="2" transform="rotate(-180 426 250)" />
        <rect
          width="13.5"
          height="13.5"
          x="425.25"
          y="249.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="1.25"
          transform="rotate(-180 425.25 249.25)"
        />
      </g>
      <g filter="url(#h)">
        <rect width="20" height="20" x="499" y="224" fill="#fff" rx="3" transform="rotate(-180 499 224)" />
        <rect
          width="18.5"
          height="18.5"
          x="498.25"
          y="223.25"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="2.25"
          transform="rotate(-180 498.25 223.25)"
        />
      </g>
      <g filter="url(#i)">
        <rect width="97.5" height="97.5" x="63.75" y="77.75" fill="#fff" stroke="#37D070" strokeWidth="1.5" rx="5.25" />
        <path fill="url(#j)" d="M84 97h58v58H84z" />
      </g>
      <g filter="url(#k)">
        <circle cx="271.6" cy="126.6" r="61.6" fill="#fff" />
        <circle cx="271.6" cy="126.6" r="60.85" stroke="#37D070" strokeWidth="1.5" />
      </g>
      <path
        fill="#40E398"
        d="M263.735 100.2h33.331c.517 0 .934.413.934.924v32.953a.927.927 0 0 1-.934.923h-34.265v-33.876a.93.93 0 0 1 .934-.924Z"
      />
      <path
        fill="#191A1C"
        d="M246.134 135h16.664v16.474a.928.928 0 0 1-.934.924h-15.73a.928.928 0 0 1-.934-.924V135.92c0-.51.418-.923.934-.923V135Z"
      />
      <g filter="url(#l)">
        <rect
          width="97.5"
          height="97.5"
          x="381.75"
          y="77.75"
          fill="#fff"
          stroke="#37D070"
          strokeWidth="1.5"
          rx="5.25"
        />
      </g>
      <path fill="url(#m)" d="M402 97h58v58h-58z" />
      <path
        fill="#37D070"
        d="m210 126-7.5-4.33v8.66L210 126Zm-48 .75h41.25v-1.5H162v1.5Zm219-.75-7.5-4.33v8.66L381 126Zm-48 .75h41.25v-1.5H333v1.5Z"
      />
      <defs>
        <filter
          id="a"
          width="66"
          height="66"
          x="26"
          y="148"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="b"
          width="66"
          height="66"
          x="452"
          y="40"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="c"
          width="42"
          height="42"
          x="0"
          y="71"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="d"
          width="42"
          height="42"
          x="502"
          y="140"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="e"
          width="28"
          height="28"
          x="41"
          y="25"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="f"
          width="23"
          height="23"
          x="113"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="g"
          width="23"
          height="23"
          x="407"
          y="231"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="h"
          width="28"
          height="28"
          x="475"
          y="200"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="i"
          width="119"
          height="119"
          x="53"
          y="71"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="k"
          width="143.2"
          height="143.2"
          x="200"
          y="59"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <filter
          id="l"
          width="119"
          height="119"
          x="371"
          y="71"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2421_102" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2421_102" result="shape" />
        </filter>
        <pattern id="j" width="1" height="1" patternContentUnits="objectBoundingBox">
          <use href="#source-image" transform="translate(-.001) scale(.00218)" />
        </pattern>
        <pattern id="m" width="1" height="1" patternContentUnits="objectBoundingBox">
          <use href="#destination-image" transform="translate(-.001) scale(.00218)" />
        </pattern>
        <image id="source-image" width="458" height="458" data-name={sourceImage} href={sourceImage} />
        <image id="destination-image" width="458" height="458" data-name={destinationImage} href={destinationImage} />
      </defs>
    </Icon>
  );
}
